export default {
  title: 'Zdjęcie oferty',
  select: {
    generate_title: 'Wygeneruj zdjęcie z AI',
    generate_subtitle: 'Stworzymy je na podstawie szczegółów Twojej oferty.',
    generate_cta: 'Generuj',
    upload_link: 'lub prześlij ze swojego urządzenia',
    rate_limit_company: {
      title: 'Potrzebujemy chwili przerwy',
      description: 'Twoja restauracja wygenerowała dużo zdjęć w tej godzinie. Spróbuj ponownie za {{time}}.',
    },
    rate_limit_offer: {
      title: 'Krótka przerwa',
      description: 'Wygląda na to, że próbowałeś tej oferty kilka razy pod rząd. Będziemy gotowi za {{time}}.',
    },
  },
  generating: {
    title: 'Generowanie zdjęcia…',
    progress: {
      cooking: 'Gotujemy coś pysznego…',
      plating: 'Nakładamy na talerz…',
      finishing: 'Dodajemy ostatnie szlify…',
    },
  },
  preview: {
    alt: 'Wygenerowane zdjęcie oferty',
    hint: 'Nie to, co chciałeś? Wygeneruj ponownie lub kontynuuj, aby przyciąć zdjęcie.',
    click_to_expand: 'Kliknij, aby powiększyć',
    regenerate: 'Wygeneruj ponownie',
    continue: 'Kontynuuj edycję',
  },
  toasts: {
    upload_success: 'Zdjęcie przesłane pomyślnie.',
    upload_failed: 'Nie udało się przesłać zdjęcia.',
    delete_success: 'Zdjęcie usunięte pomyślnie.',
    delete_failed: 'Nie udało się usunąć zdjęcia.',
    generate_success: 'Zdjęcie wygenerowane pomyślnie.',
    generate_failed: 'Nie udało się rozpocząć generowania zdjęcia.',
    generate_timeout: 'Zdjęcie jest nadal generowane. Pojawi się tutaj, gdy będzie gotowe.',
    rate_limit_company: 'Osiągnięto godzinny limit zdjęć dla tej restauracji. Spróbuj ponownie za {{time}}.',
    rate_limit_offer: 'Zbyt wiele prób dla tej oferty — spróbuj ponownie za {{time}}.',
  },
  time: {
    seconds_one: '1 sekunda',
    seconds_few: '{{count}} sekundy',
    seconds_many: '{{count}} sekund',
    seconds_other: '{{count}} sekund',
    minutes_one: '1 minuta',
    minutes_few: '{{count}} minuty',
    minutes_many: '{{count}} minut',
    minutes_other: '{{count}} minut',
    hours_one: '1 godzina',
    hours_few: '{{count}} godziny',
    hours_many: '{{count}} godzin',
    hours_other: '{{count}} godzin',
  },
};
